
import tabs from './tabs';
import video from './video';
import burger from './burger';
import dropMenu from './dropMenu';

import './Loadtext';
import './modals';
import './glideSlider';
import './popup';


tabs();
video();
burger();
dropMenu();